/**
 * Share labels across the connect, loading, and results screens so the promised statistics match those
 * displayed.
 */
import type { CalendarScanStats } from "~vue/CalendarFirstOnboarding/types";
import { i18n } from "~vue/i18n";
import { formatNumber } from "~vue/utils/formatNumber";

export interface StatTile {
    label: string;
    value: string;
}

export function formatHours(hours: number): string {
    return formatNumber(hours, "up-to-one-decimal");
}

/**
 * Omit zero-valued tiles because sparse calendars have dedicated explanatory copy; a row of zeros can
 * suggest a failed scan.
 */
export function statTiles(stats: CalendarScanStats | null): StatTile[] {
    if (stats === null) {
        return [];
    }
    const { t } = i18n.global;
    const tiles: StatTile[] = [];
    if (stats.hours_per_week > 0) {
        tiles.push({ label: t("onboarding.calendarFirst.stats.hoursPerWeek"), value: formatHours(stats.hours_per_week) });
    }
    if (stats.organized_count > 0) {
        tiles.push({ label: t("onboarding.calendarFirst.stats.organized"), value: `${stats.organized_count}` });
    }
    if (stats.back_to_back_count > 0) {
        tiles.push({ label: t("onboarding.calendarFirst.stats.backToBack"), value: `${stats.back_to_back_count}` });
    }
    if (stats.recurring_series_count > 0) {
        tiles.push({ label: t("onboarding.calendarFirst.stats.recurring"), value: `${stats.recurring_series_count}` });
    }
    return tiles;
}
